
import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface CustomerFilterDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onApplyFilters: (filters: any) => void;
  onClearFilters: () => void;
  initialFilters: any;
}

export function CustomerFilterDialog({
  open,
  onOpenChange,
  onApplyFilters,
  onClearFilters,
  initialFilters,
}: CustomerFilterDialogProps) {
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    setFilters(initialFilters);
  }, [initialFilters]);

  const handleApplyFilters = () => {
    onApplyFilters(filters);
  };

  const handleClearFilters = () => {
    setFilters({
      nameFilter: "",
      platformFilter: "",
      statusFilter: "",
      dddFilter: "",
      minSpendFilter: "",
      maxSpendFilter: "",
      minPurchasesFilter: "",
    });
    onClearFilters();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Filtrar Clientes</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="nameFilter">Nome do Cliente</Label>
            <Input
              id="nameFilter"
              placeholder="Digite o nome..."
              value={filters.nameFilter}
              onChange={(e) => setFilters(prev => ({ ...prev, nameFilter: e.target.value }))}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="platformFilter">Plataforma</Label>
            <Select 
              value={filters.platformFilter} 
              onValueChange={(value) => setFilters(prev => ({ ...prev, platformFilter: value }))}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione a plataforma" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="">Todas</SelectItem>
                <SelectItem value="nuvemshop">Nuvemshop</SelectItem>
                <SelectItem value="shopify">Shopify</SelectItem>
                <SelectItem value="woocommerce">WooCommerce</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="statusFilter">Status</Label>
            <Select 
              value={filters.statusFilter} 
              onValueChange={(value) => setFilters(prev => ({ ...prev, statusFilter: value }))}
            >
              <SelectTrigger>
                <SelectValue placeholder="Selecione o status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="">Todos</SelectItem>
                <SelectItem value="active">Ativo</SelectItem>
                <SelectItem value="inactive">Inativo</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label htmlFor="dddFilter">DDD</Label>
            <Input
              id="dddFilter"
              placeholder="Ex: 11"
              value={filters.dddFilter}
              onChange={(e) => setFilters(prev => ({ ...prev, dddFilter: e.target.value }))}
            />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-2">
              <Label htmlFor="minSpendFilter">Gasto Mínimo (R$)</Label>
              <Input
                id="minSpendFilter"
                type="number"
                placeholder="0"
                value={filters.minSpendFilter}
                onChange={(e) => setFilters(prev => ({ ...prev, minSpendFilter: e.target.value }))}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="maxSpendFilter">Gasto Máximo (R$)</Label>
              <Input
                id="maxSpendFilter"
                type="number"
                placeholder="10000"
                value={filters.maxSpendFilter}
                onChange={(e) => setFilters(prev => ({ ...prev, maxSpendFilter: e.target.value }))}
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="minPurchasesFilter">Mínimo de Compras</Label>
            <Input
              id="minPurchasesFilter"
              type="number"
              placeholder="1"
              value={filters.minPurchasesFilter}
              onChange={(e) => setFilters(prev => ({ ...prev, minPurchasesFilter: e.target.value }))}
            />
          </div>
        </div>

        <div className="flex gap-2 pt-4">
          <Button variant="outline" onClick={handleClearFilters} className="flex-1">
            Limpar Filtros
          </Button>
          <Button onClick={handleApplyFilters} className="flex-1">
            Aplicar Filtros
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
